export enum Sexo {
    MASCULINO = 'MASCULINO',
    FEMININO = 'FEMININO'
  }
  